import { LocalizationKeys } from './constant';

const en: LocalizationKeys = {
	skip: 'Skip',
};

export default en;
